module.exports = __webpack_public_path__ + "img/paishui1.f5b8a216.png";